import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Button,
  Popover,
  useMediaQuery,
  Avatar,
  Drawer,
  Typography,
  Divider,
} from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import EmailIcon from "@material-ui/icons/Email";

import inviteActions from "./actions";
import { useSelector } from "react-redux";
import { INVITE_PROP } from "./constants";
import { UserRoleText } from "components/User/constants";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  box: {
    margin: theme.spacing(1),
  },
  bold: {
    fontWeight: 600,
    marginRight: theme.spacing(1),
  },
  AvatarSmall: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(2),
  },
  popoverItemDelete: {
    color: "#E16B66",
  },
}));

const TableActions = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const { deleteInvite, resendInvite } = inviteActions();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const { editInvite } = useSelector((state) => state.invites);

  const deleteInvitation = () => {
    setAnchorEl(null);
    deleteInvite();
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  const resendInvitation = () => {
    setAnchorEl(null);
    resendInvite();
  };
  const getActions = () => (
    <Box className={classes.box}>
      <Grid container direction="column">
        <Button
          size="large"
          onClick={() => {
            resendInvitation();
          }}
          className={classes.popoverItem}
        >
          Resend Invite
        </Button>
        <Button
          size="large"
          color="secondary"
          onClick={() => deleteInvitation()}
          className={classes.popoverItemDelete}
        >
          Cancel Invitation
        </Button>
      </Grid>
    </Box>
  );
  return (
    <Box>
      <Button
        aria-describedby={id}
        onClick={(event) => {
          setAnchorEl(event.currentTarget);
        }}
      >
        {matches ? <MoreHorizIcon /> : <MoreVertIcon />}
      </Button>
      {matches ? (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => {
            setAnchorEl(null);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          {getActions()}
        </Popover>
      ) : (
        <Drawer
          anchor="bottom"
          open={open}
          onClose={() => {
            setAnchorEl(null);
          }}
        >
          {editInvite[INVITE_PROP.EMAIL] && (
            <Box p={3}>
              <Box m={2}>
                <Grid
                  container
                  justify="flex-start"
                  alignItems="center"
                  direction="row"
                >
                  <Avatar className={classes.AvatarSmall}>
                    <EmailIcon />
                  </Avatar>
                  <Typography variant="h5">
                    {editInvite[INVITE_PROP.EMAIL]}
                  </Typography>
                </Grid>
              </Box>
              <Box m={2}>
                <Grid
                  container
                  justify="flex-start"
                  alignItems="center"
                  direction="row"
                >
                  <Typography className={classes.bold} variant="subtitle1">
                    {"Role:"}
                  </Typography>
                  <Typography variant="subtitle1">
                    {UserRoleText[editInvite[INVITE_PROP.ROLE]]}
                  </Typography>
                </Grid>
              </Box>
              <Box m={2}>
                <Grid
                  container
                  justify="flex-start"
                  alignItems="center"
                  direction="row"
                >
                  <Typography className={classes.bold} variant="subtitle1">
                    {"Status:"}
                  </Typography>
                  <Typography variant="subtitle1">
                    {editInvite[INVITE_PROP.STATUS]}
                  </Typography>
                </Grid>
              </Box>
              <Box m={2}>
                <Grid
                  container
                  justify="flex-start"
                  alignItems="center"
                  direction="row"
                >
                  <Typography className={classes.bold} variant="subtitle1">
                    {"Expire On:"}
                  </Typography>
                  <Typography variant="subtitle1">
                    {moment(editInvite[INVITE_PROP.EXPIRY_DATE]).format(
                      "MMM, DD YYYY"
                    )}
                  </Typography>
                </Grid>
              </Box>
            </Box>
          )}
          <Divider />
          {getActions()}
        </Drawer>
      )}
    </Box>
  );
};

export default TableActions;
